export const API_BASE_URL = "https://api.billattable.iosx.in/api/v1/";
export const API_IMAGE_URL = "https://api.billattable.iosx.in/";
export const SOCKET_URL = "https://api.billattable.iosx.in";

// export const API_BASE_URL = "https://api.billattable.com/api/v1/";
// export const API_IMAGE_URL = "https://api.billattable.com/";
// export const SOCKET_URL = "https://api.billattable.com";



// export const API_BASE_URL = "http://127.0.0.1:4549/api/v1/";
// export const API_IMAGE_URL = "http://127.0.0.1:4549/";